import styled from "@emotion/styled"
import PopperContainer from "../../components/Radiate/PopperContainer/PopperContainer"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ReactTooltip from "@huner2/react-tooltip"

import ToggleField from "../../components/Radiate/ToggleField/ToggleField"
import TextField from "../../components/Radiate/TextField/TextField"
import Checkbox from "../../components/Radiate/Checkbox/Checkbox"

export const TextInput = styled.input`
  font-size: 0.9em;
  color: #626262;
  outline: none;
  margin-bottom: 3px;
  margin-top: 2px;
  margin-right: 4px;
  padding: 6px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  overflow: hidden;
  overflow-wrap: break-word;
  width: 100%;
  box-sizing: border-box;
  height: ${(props) => props.borderStyle === "M" && "38px"};
  background-color: ${(props) => props.disabled && props.theme.paleBackground};
`

export const ContentWrapper = styled.div`
  display: ${(props) => props.block ? "block" : "flex"};
  padding: ${(props) => props.block ? "32px 8px 0px 8px" : "32px 8px;"};
  background: #ffffff ;

  &:first-child {
    padding-top: 0px;
  }

  >.label {
    color: ${(props) => props.theme.gray6};
    width: 30%;
    box-sizing: border-box;
    padding-right: 30px;

    .subtitle {
      font-size: ${(props) => props.theme.textMd};
      font-weight: bold;
    }

    .text {
      padding: 8px 0;
      line-height: ${(props) => props.theme.spaceMd};
      font-size: 0.9rem;
    }
  }

  >.language-label {
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.gray6};
    box-sizing: border-box;
    padding-right: 30px;

    .subtitle {
      font-size: ${(props) => props.theme.textLg};
      font-weight: bold;
    }
  }

  .info-content-wrapper {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 70%;
    padding-left: 16px;

    &.block {
      display: block;
    }
    
    .pic-preview {
      width: 72px;
      height: 72px;
      border-radius: 36px;
      overflow: hidden;
      background: #eee;
      margin-right: 16px;
      flex-shrink: 1;
      object-fit: cover;
    }

    .url-container {
      display: flex;
      border: 1px solid ${(props) => props.theme.gray1};
      border-radius: 4px;
      font-size: ${(props) => props.theme.textSm};
      word-break: break-all;
       color: ${(props) => props.theme.gray7};

      >.url-wrapper {
        font-weight: bold;
        border-right: 1px solid ${(props) => props.theme.gray1};
        padding: 16px;
       
        .url {
          cursor: pointer;

          &:hover {
            color: ${(props) => props.theme.themeColorLight};
          }
        }
      }

      >.button-wrapper {
        display: flex;
        align-items: center;
      }
    }
  }
`

export const ActionBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 56px;
  border-bottom: 1px solid #e8e7e8;
  position: sticky;
  background: #ffffff;
  top: 0;
  z-index: 99;

  .box-button {
    border: 1px solid rgb(204,204,204);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 6px 10px;
    min-width: 34px;
    min-height: 34px;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`


export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.error};
  font-size: 0.75rem;
  padding-right: 8px;
`

export const StyledPopperContainer = styled(PopperContainer)`
  >.popper-dropdown {
    margin: 8px;
  }
`

export const ColorDisplayBorder = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 21px;
  border: 2px solid #ffffff;
  border-color: ${(props) => (props.selected ? props.color : "#ffffff")};
  background-color: #ffffff;
  margin: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => props.readOnly ? "inherit" :"pointer"};
  
`

export const ColorDisplay = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  background-color: ${(props) => props.color};
  background-image: url(${(props) => props.image});
  background-size: cover;
`

export const CodeEditorWrapper = styled.div`
  padding: 8px 0;
  margin: 0 8px;
  width: 100%;
  background-color: #002240;
`

export const ListHeader = styled.li`
  display: flex;
  list-style-type: none;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid ${(props) => props.theme.gray1};
  font-size: ${(props) => props.theme.textSm};

  div {
    padding: 0 16px;
  }
`

export const ListRow = styled.li`
  list-style-type: none;
  padding: 16px 0;
`

export const WarningIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.gray4};
  font-size: ${(props) => props.theme.textMd};
  margin-left: 2px;
  padding: 0 4px;
`

export const StyledTooltip = styled(ReactTooltip)`
  padding: 6px 8px !important;

  &:before, &:after {
    border-width: 0px !important;
  }
`

export const DefaultToggleField = styled(ToggleField)`
  margin: 0 16px;

  >.content {
    margin-left: 0;
  }
`

export const DropdownIcon = styled(FontAwesomeIcon)`
  margin-right: 24px;
  cursor: pointer;
  color: ${(props) => props.theme.gray4};
`

export const AddMoreButton = styled.div`
  border: 2px dashed #aaa;
  width: 90%;
  margin: 8px 0;
  font-size: 0.9rem;
  color: #777;
  padding: 8px;
  border-radius: 8px;
  text-align: center;
  box-sizing: border-box;
  cursor: inherit;

  .icon {
    margin-right: 8px;
  }

  &:hover {
    color: ${(props) => props.theme.themeColorLight};
    border-color: ${(props) => props.theme.themeColorLight};
  }
`

export const PersistentMenuSettings = styled.div`
  min-height: 320px;
  display: flex;

    .preview-container {
      width: 50%;
      background: ${(props) => props.theme.paleBackground};
      display: flex;
      justify-content: center;
      align-items: center;

      .pm-container {
        width: 320px;
        background: ${(props) => props.theme.palerBackground};
        margin: 32px 0;

        >.top-bar {
          padding: 8px 8px 0 8px;
          display: flex;
          justify-content: center;

          .bar {
            width: 40px;
            height: 5px;
            display: inline-block;
            border-radius: 2.5px;
            background: #ddd;
          }
        }
        .pm-content {
          display: flex;
          flex-direction: column;
          align-items: center;

          .fake-input {
            height: 32px;
            border-radius: 16px;
            background: #eee;
            width: calc(100% - 16px);
            margin: 8px;
            color: #aaa;
            padding: 0 16px;
            box-sizing: border-box;
            line-height: 32px;
            font-size: 0.9rem;   
          }

          .pm-nav-bar {
            width: 100%;
            position: relative;
            text-align: center;
            height: 44px;

            span {
              line-height: 44px;
            }

            .prev-icon-container {
              position: absolute;
              top: 6px;
              left: 8px;
              background: #eee;
              width: 32px;
              height: 32px;
              display: flex;
              border-radius: 16px;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              .icon {
                color: #ccc;
              }
            }
          }
        }

        .buttons-container {
          width: 100%;
        }
        
        .pm-button {
          height: 44px;
          background: ${(props) => props.theme.palerBackground};
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
          cursor: pointer;
          padding: 8px;
          color: #222;

          &.general {
            justify-content: flex-start;
          }

          .icon {
            color: #ccc;
          }

          .next-icon-container {
            background: #eee;
            width: 32px;
            height: 32px;
            display: flex;
            border-radius: 16px;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }

          &.selected {
            background: ${(props) => props.theme.themeColorLight};
            color: white;

            .next-icon-container {
              background: ${(props) => props.theme.themeColorSolid};
            }              
          }

          .drag-handle {
            margin-right: 8px;
          }

          &.nested {
            .align-left {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  }
`

export const SettingsContainer = styled.div`
  width: 50%;
  box-sizing: border-box;
  background: white;
  padding: 16px;

  .title {
    color: ${(props) => props.theme.gray6};
    font-weight: 600;
    font-size: ${(props) => props.theme.textMd};
  }

  >.top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  
    .remove-button {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }
`

export const PersistentMenuAdvancedSettings = styled.div`
  min-height: 320px;

  .advanced-pm-editor {
    height: 457px;
  } 
`

export const PersistentMenuSettingsContainer = styled.div`
  border: 1px solid ${(props) => props.theme.paleBackground};
  border-radius: 4px;
  overflow: hidden;
  margin-top: 16px;

  >.top-bar {
    position: relative;
    padding: 8px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
    background: ${(props) => props.theme.palerBackground};
    display: flex;
    justify-content: space-between;
    align-items: center;

    .locale-selector {
      width: 20%;
      min-width: 200px;
    }
  }
`

export const LoadingContainer = styled.div`
  min-height: 400px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  >svg {
    width: 28px !important;
    height: 28px;
    color: ${(props) => props.theme.gray4};
  }
`

export const UnauthContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.gray7};
  font-size: 0.8rem;
  flex-direction: column;
  overflow: hidden ;
`

export const StyledTextField = styled(TextField)`
  margin-bottom: 8px;
`

export const StyledCheckbox = styled(Checkbox)`
  margin-bottom: 8px;
`